const notifications = require('../lib/notifications');
const formValidation = require('../lib/formValidation');
const formSubmission = require('../lib/formSubmission');

window.addEventListener('load', function() {

    const resetPasswordForm = document.getElementById('frm-resetpassword');

    const success = function () {
        let content = document.getElementById('content');
        const formContainer = content.getElementsByClassName('form-container')[0];

        formContainer.innerHTML = '<div class="frm-crud">' +
                '<div class="header">Neues Passwort unterwegs</div>' +
                '<div class="form-description">Falls deine eingegebene Email-Adresse gefunden werden kann und mit dem hinterlegten Geburtsdatum Ã¼bereinstimmt, dann findest du ' +
                'in KÃ¼rze ein neues Passwort in deiner Email-Inbox.<br><br>Melde dich mit dem neuen Passwort <a href="/sign-in">hier</a> an.</div>' +
                '</div>';

        return null;
    };

    notifications.init(resetPasswordForm);
    formValidation.validateFormDataOnFormSubmission(resetPasswordForm);
    formSubmission.submitFormDataWithRecaptchaOnFormSubmission(resetPasswordForm, success);

});
